import type { FeatureUnlock } from "@indietabletop/types";
import { useUnlocksResult } from "../CheckAccess/context";

export function useIsFeatureUnlocked(feature: FeatureUnlock["feature"]) {
  const unlocksResult = useUnlocksResult();

  return (
    unlocksResult.isSuccess &&
    unlocksResult.value.unlocks.some((u) => u.feature === feature)
  );
}
